"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtil = void 0;
const humanize_duration_1 = __importDefault(require("humanize-duration"));
class DateUtil {
    static formatDate(timeStamp) {
        const date = new Date(timeStamp);
        const month = date.toLocaleString("en-US", { month: "long" });
        return `${month} ${date.getDate()}, ${date.getFullYear()}`;
    }
    // 日期格式 "2024-03-28 16:00:00" 转为 "1h ago"
    static calculateTimeAgo(timestamp) {
        const givenTime = new Date(timestamp);
        const currentTime = new Date();
        const timeDifference = currentTime.getTime() - givenTime.getTime();
        const shortEnglishHumanizer = humanize_duration_1.default.humanizer({
            largest: 1,
            round: true,
            spacer: "",
            language: "shortEn",
            languages: {
                shortEn: {
                    y: () => "y",
                    mo: () => "mo",
                    w: () => "w",
                    d: () => "d",
                    h: () => "h",
                    m: () => "m",
                    s: () => "s",
                    ms: () => "ms",
                },
            },
        });
        const readableTimeDifference = shortEnglishHumanizer(timeDifference);
        return `${readableTimeDifference} ago`;
    }
}
exports.DateUtil = DateUtil;
